import {Link, useLocation} from "react-router-dom";
import {useEffect, useState} from "react";

const logo = process.env.PUBLIC_URL + "/assets/icon/LogoMini.svg"
const links = [
    {url: "home", name: "home"},
    {url: "about", name: "about us"},
    {url: "projects", name: "our work"},
    {url: "our_showreels", name: "showreels"},
    {url: "career", name: "career"},
    {url: "contacts", name: "contact"},
]

const Footer = () => {
    const {pathname} = useLocation();
    const reg = new RegExp('/projects*');
    const [isActive, setIsActive] = useState(reg.test(pathname))

    useEffect(() => {
        window.innerWidth > 991 ?
            setIsActive(reg.test(pathname))
            :
            setIsActive(false)
    }, [pathname])
    return (
        <footer className={`${isActive ? "/*active*/" : ""} footer flex col center`}>
            {/*<div className="flex center space-b">*/}
                {/*<div className="logo-mini-cont">*/}
                {/*    <Link className="logo-mini" to='/'>*/}
                {/*        <img className="logo-img" src={logo} alt="logo"/>*/}
                {/*    </Link>*/}
                {/*</div>*/}
                {/*<nav className="nav flex">*/}
                {/*    {links.map(link =>*/}
                {/*        <Link className="nav__link flex col center gray"*/}
                {/*              key={link.name} to={`/${link.name === "home" ? "" : link.name}`}>*/}
                {/*            <div className="small">*/}
                {/*                {link.name.toUpperCase()}*/}
                {/*            </div>*/}
                {/*            <div className="dot nav__dot"></div>*/}
                {/*        </Link>*/}
                {/*    )}*/}
                {/*</nav>*/}
                {/*<div className="social flex">*/}
                {/*    <Social props="light"/>*/}
                {/*</div>*/}
            {/*</div>*/}
            <nav className="nav flex">
                {links.map(link =>
                    <Link className="nav__link flex col center gray"
                          key={link.url} to={`/${link.url === "home" ? "" : link.url}`}>
                        <div className="small">
                            {link.name.toUpperCase()}
                        </div>
                        <div className="dot nav__dot"></div>
                    </Link>
                )}
            </nav>
        </footer>
    )
}
export default Footer